export class FileDownload {

  public static download(data: string, type: string, fileName: string) {
    const blob = new Blob(
      [ data ],
      { type }
    );
    const url = URL.createObjectURL(blob);
    this.triggerDownload(url, fileName);
  }

  // Navigates to a URL via a temporary <a download> link.
  // For a (presigned) URL served with `Content-Disposition: attachment` the
  // browser downloads the file instead of opening it — no fetch, so cross-origin
  // CORS is irrelevant. Object URLs (blob:) are revoked after use.
  public static triggerDownload(url: string, fileName = '') {
    const downloadLink = document.createElement('a');
    try {
      downloadLink.href = url;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
    } finally {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
      downloadLink.remove();
    }
  }
}
